/**
 * @external FetchResponse https://fetch.spec.whatwg.org/#responses
 */

/**
 * Exception for cases when 4xx or 5xx response is received
 *
 * @access public
 */
class FetchFailureError extends Error {
  /**
   * @param {FetchResponse} response WHATWG Fetch HTTP response
   */
  constructor(response) {
    var statusCode = response.status;
    super("Request failed with status code ".concat(statusCode));
    /**
     * @constant
     * @type {"FetchFailureError"}
     */

    this.name = "FetchFailureError";
    /**
     * @readonly
     * @type {number}
     *
     * @access public
     */

    this.statusCode = statusCode;
  }

}
/**
 * Exception for cases when key is used before it was marked for fetching
 *
 * @access public
 */

class UndeclaredKeyError extends Error {
  /**
   * @param {string} key Key that caused the error
   */
  constructor(key) {
    super("Key \"".concat(key, "\" could not be resolved. Make sure it is prefetched with \"I18n.preload\" or passed to \"I18n.useTranslate\" hook"));
    /**
     * @constant
     * @type {"UndeclaredKeyError"}
     */

    this.name = "UndeclaredKeyError";
  }

}
/**
 * Exception for cases when unknown processor name was used by content
 *
 * @access public
 */

class UnknownSourceError extends Error {
  /**
   * @param {string} source Source type that caused the error
   */
  constructor(source) {
    super("Source \"".concat(source, "\" is not supported. Supported sources are available in \"I18n.SourceType\" enum."));
    /**
     * @constant
     * @type {"UnknownSourceError"}
     */

    this.name = "UnknownSourceError";
  }

}
/**
 * Exception for cases when unknown processor name was used by content
 *
 * @access public
 */

class UnknownProcessorError extends Error {
  /**
   * @param {string} processor Processor name that caused the error
   */
  constructor(processor) {
    super("Processor \"".concat(processor, "\" could not be found. Make sure you pass it to \"I18n.TranslationProvider\" in \"processors\" prop"));
    /**
     * @constant
     * @type {"UnknownProcessorError"}
     */

    this.name = "UnknownProcessorError";
  }

}

export { FetchFailureError, UndeclaredKeyError, UnknownProcessorError, UnknownSourceError };
